import type { ReactElement } from 'react';
import { useEffect } from 'react';
import * as React from 'react';
import { Modal, Button } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

interface PromptVerifyEmailContentsProps {
  onClose: () => void;
  onProceed: () => void;
}

export const PromptVerifyEmailContents = ({
  onClose,
  onProceed,
}: PromptVerifyEmailContentsProps): ReactElement => {
  const { t } = useTranslationWithPrefix('mfa:enable-modal:prompt-verify-email');
  const { loadedModal } = useTrack();

  useEffect(() => {
    // Track event on first render only
    loadedModal('Verify Email - MFA Flow', undefined, {});
  }, [loadedModal]);

  return (
    <>
      <Modal.Body>
        <p>{t('description')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button kind="primary" onClick={onProceed} type="submit">
          {t('action')}
        </Button>
      </Modal.Footer>
    </>
  );
};
